module.exports = __webpack_public_path__ + "img/meanDisbursementChart.bc2f61c4.svg";